<!-- PAGE HEADER -->
<div class="page-header">
  <div class="page-header-left">
    <div class="page-header-icon">📊</div>
    <div>
      <div class="page-header-title">Test Analytics</div>
      <div class="page-header-sub">
        Monitor and analyze answer sheet submissions
      </div>
    </div>
  </div>

  <div class="badge-total">🗂 {{ totalDataCount }} Total Records</div>
</div>

<!-- FILTER CARD -->
<!-- FILTER CARD -->
<div class="filter-card">
  <div class="filter-card-header">⚙️ Filters</div>

  <div nz-row [nzGutter]="[16, 16]">
    <!-- Test Series -->
    <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">📁 Test Series</div>
        <nz-select
          nzAllowClear
          nzShowSearch
          nzServerSearch
          [(ngModel)]="selectedTestSeries"
          nzPlaceHolder="Select Test Series"
          (nzOnSearch)="searchTestSeriesForDropdown($event)"
          (ngModelChange)="onChangeTestSeries()"
        >
          <nz-option
            *ngFor="let item of allTestSeries"
            [nzValue]="item._id"
            [nzLabel]="item.name"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Test -->
    <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">📄 Test</div>
        <nz-select
          nzAllowClear
          nzShowSearch
          nzServerSearch
          [(ngModel)]="selectedTest"
          nzPlaceHolder="Select Test"
          (nzOnSearch)="searchTestForDropdown($event)"
          (ngModelChange)="onChangeTest()"
        >
          <nz-option
            *ngFor="let item of allTests"
            [nzValue]="item._id"
            [nzLabel]="item.name"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- User -->
    <div nz-col nzXs="24" nzSm="12" nzMd="8" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">👤 User</div>
        <nz-select
          nzAllowClear
          nzShowSearch
          nzServerSearch
          [(ngModel)]="selectedUser"
          nzPlaceHolder="Select User"
          (nzOnSearch)="searchUserForDropdown($event)"
          (ngModelChange)="onChangeUser()"
        >
          <nz-option
            *ngFor="let item of allUsers"
            [nzValue]="item._id"
            [nzLabel]="item.name"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Date Range -->
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <nz-form-item>
        <div class="filter-label">📅 Date Range</div>
        <nz-form-control [nzSpan]="24" nzErrorTip="Please select a Date!">
          <nz-range-picker
            class="width-100"
            [(ngModel)]="dateRange"
            (ngModelChange)="onChangeDateRange($event)"
          ></nz-range-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="6">
      <div class="filter-group">
        <div class="filter-label">Submission Status</div>
        <nz-select
          class="width100"
          nzAllowClear
          nzPlaceHolder="Filter by Submission"
          [(ngModel)]="selectedSubmissionStatus"
          (ngModelChange)="onFilterChange()"
        >
          <nz-option nzLabel="Submitted" [nzValue]="'true'"></nz-option>
          <nz-option nzLabel="Pending" [nzValue]="'false'"></nz-option>
        </nz-select>
      </div>

      <!-- Search -->
      <!-- <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="8">
        <div class="filter-group">
          <div class="filter-label">🔍 Search</div>
          <nz-input-group [nzPrefix]="searchIcon">
            <input
              nz-input
              placeholder="Search answer sheets..."
              [ngModel]="search"
              (ngModelChange)="searchAnswerSheets($event)"
            />
          </nz-input-group>
          <ng-template #searchIcon>
            <i nz-icon nzType="search"></i>
          </ng-template>
        </div>
      </div> -->
    </div>
  </div>

  <!-- TABLE CARD -->
</div>
<div class="table-card">
  <!-- <div class="table-card-header">
    <div class="table-card-title">📋 Answer Sheets</div>
    <div class="table-meta">
      Showing <strong>{{ allAnswerSheets.length }}</strong> of
      <strong>{{ totalDataCount }}</strong>
    </div>
  </div> -->

  <nz-table
    [nzData]="allAnswerSheets"
    [nzLoading]="loading"
    [nzTotal]="totalDataCount"
    [(nzPageSize)]="pageSize"
    [nzPageIndex]="pageIndex"
    [nzFrontPagination]="false"
    nzShowSizeChanger
    (nzQueryParams)="onQueryParamsChange($event)"
  >
    <thead>
      <tr>
        <!-- <th nzWidth="50px"></th> -->
        <th nzWidth="150px">Test Series</th>
        <th nzWidth="150px">Test</th>
        <th nzWidth="150px">User</th>
        <th nzWidth="120px">exam Type</th>
        <th nzWidth="120px">Submitted</th>
        <th nzWidth="120px">Total Time</th>
        <th nzWidth="120px">Completed Time</th>
        <th nzWidth="120px">Submitted Date</th>
        <th nzWidth="100px">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of allAnswerSheets">
        <td class="cell-series">
          {{ data.testSeries?.name || "N/A" }}
        </td>

        <td class="cell-test">
          {{ data.test?.name || "N/A" }}
        </td>

        <!-- USER -->
        <td>
          <div class="user-cell">
            <div class="avatar">
              {{ (data.user?.name || "U")[0] }}
            </div>
            <span class="user-name">
              {{ data.user?.name || "N/A" }}
            </span>
          </div>
        </td>

        <!-- EXAM TYPE -->
        <td>
          <span class="tag" [ngClass]="getExamTypeClass(data.examType)">
            {{ data.examType || "N/A" }}
          </span>
        </td>

        <!-- STATUS -->
        <td>
          <span
            class="tag"
            [ngClass]="data.isSubmitted ? 'tag-submitted' : 'tag-pending'"
          >
            {{ data.isSubmitted ? "✔ Submitted" : "✖ Not Submitted" }}
          </span>
        </td>

        <!-- TIME -->
        <td class="text-center">
          <span class="time-total">
            {{ formatTime(data.time) }}
          </span>
        </td>

        <td class="text-center">
          <span class="time-done">
            {{ formatTime(data.completedTime) }}
          </span>
        </td>

        <!-- DATE -->
        <td>
          <div class="date-primary">
            {{ data.createdAt | date: "dd MMM yyyy" }}
          </div>
          <div class="date-secondary">
            {{ data.createdAt | date: "HH:mm:ss" }}
          </div>
        </td>
        <td>
          <a
            nz-button
            nzType="link"
            nz-tooltip
            nzTooltipTitle="Details"
            nzTooltipPlacement="topCenter"
            [routerLink]="['/main/user/detail-answer-sheet', data._id]"
            routerLinkActive="router-link-active"
          >
            <i nz-icon nzType="eye" nzTheme="outline"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
